import { render } from "./DashboardStatuspages.vue?vue&type=template&id=086c8b3e"
import script from "./DashboardStatuspages.vue?vue&type=script&lang=js"
export * from "./DashboardStatuspages.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__